import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54b201ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row cheque-list-item" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-4 col-xl-2" }
const _hoisted_5 = { class: "col-6 col-xl-6" }
const _hoisted_6 = { class: "col-2 col-xl-4" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 col-xl-3 text-right text-nowrap small text-secondary" }
const _hoisted_9 = { class: "col-12 col-xl-3 text-right text-nowrap small text-secondary" }
const _hoisted_10 = { class: "col-12 col-xl-3 text-right text-nowrap small" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-8 offset-4 col-xl-10 offset-xl-2 text-right" }

import AppImageLightBox from "@/components/app/AppImageLightBox.vue";
import SilpoCategoryPath from "@/components/shopping/silpo/SilpoCategoryPath.vue";

interface Props {
  vendorCode: number,
  name: string,
  imageUrl: string,
  price: number,
  quantity: string,
  categoryId: number,
  totalPrice: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoChequeListItem',
  props: {
    vendorCode: null,
    name: null,
    imageUrl: null,
    price: null,
    quantity: null,
    categoryId: null,
    totalPrice: null
  },
  setup(__props: any) {

const props = __props as {
  vendorCode: number,
  name: string,
  imageUrl: string,
  price: number,
  quantity: string,
  categoryId: number,
  totalPrice: string,
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AppImageLightBox, {
            style: {"width":"100%"},
            images: [props.imageUrl],
            alt: props.name,
            "loading-image": "/images/square-placeholder.jpeg"
          }, null, 8, ["images", "alt"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, _toDisplayString(props.name), 1),
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "additions")
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(props.quantity), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(props.price) + "грн.", 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(props.totalPrice), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (props.categoryId)
            ? (_openBlock(), _createBlock(SilpoCategoryPath, {
                key: 0,
                "category-id": props.categoryId,
                "vendor-code": props.vendorCode
              }, null, 8, ["category-id", "vendor-code"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})